module.exports = __webpack_public_path__ + "files/ce7f978c8bc5375bee01f2323dc13f23.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bolditalic-webfont.woff
// module id = 927
// module chunks = 60